// 📁 chartUtils.ts
export const chartConfigGenerator = (chartData, config) => {
  const cfg = config[0];

  // Create categories = Month names (January → December)
  const categories = cfg.yKeys.map((month) => month.name);
  const chartType = cfg.yKeys[0]?.type || "column";
  const colors = config[0]?.x?.colors ;

  // Each series = one year
  const series = chartData.map((yearItem) => ({
    name: yearItem.x.toString(), // Year label (e.g. "2024")
    data: cfg.yKeys.map((month) => Number(yearItem[month.key] || 0)), // 12 months' data
    type: chartType,

  }));

  return { series, categories, chartType , colors };
};






export const lineChartConfigGenerator = (chartData, config) => {
  const cfg = config[0];
  const xKey = "x"; // hardcoded since you're not using key mapping

  const yKeys = Object.keys(cfg).filter(
    (key) => key !== "x" && key !== "groupBy"
  );

  const categories = chartData.map((item) => item[xKey]);

  const series = yKeys.map((yKey) => {
    const yField = cfg[yKey];
    return {
      name: yField?.name || yKey,
      type: yField?.type || "line",
      data: chartData.map((item) => Number(item[yKey] || 0)),
      style: Number(yField?.style ?? 0),

    };
  });

  const chartType = cfg[yKeys[0]]?.type || "line";
  const yAxisTitle = cfg[yKeys[0]]?.title || "Y Axis";
  const xAxisTitle = cfg?.x?.title || "X Axis";
  const format = cfg[yKeys[0]]?.format || "number";
  const colors = cfg?.x?.colors || ["#3b82f6"];

  return {
    series,
    categories,
    chartType,
    yAxisTitle,
    xAxisTitle,
    colors,
    format,
  };
};


export const barChartConfigGenerator = (chartData, config) => {

  const format = config[0]?.y1?.format || "number";

  const cfg = config[0];
  const xKey =  "x";

  // Extract all y keys (e.g., y1, y2, etc.)
  const yKeys = Object.keys(cfg).filter(
    (key) => key !== "x" && key !== "groupBy"
  );

  // X-axis categories
  const categories = chartData.map((item) => item[xKey]);

  // Series data
  const series = yKeys.map((yKey) => {
    const yField = cfg[yKey];
    return {
      name: yField?.name || yKey,
      data: chartData.map((item) => Number(item[yKey] || 0)),
    };
  });

  // Flatten all values for min/max calculation
  const allValues = series.flatMap((s) => s.data);
  const min = Math.min(...allValues);
  const max = Math.max(...allValues);

  // Dynamic colors per series
  const colors = series.map((_, idx) => {
    const palette = config[0]?.x.colors ;
    return palette[idx % palette.length];
  });

  return {
    categories,
    series,
    min,
    max,
    xAxisTitle: cfg?.x?.title || "X Axis",
    yAxisTitle: cfg?.[yKeys[0]]?.title || "Y Axis",
    colors,
    format,
  };
};





export const dynamicColumnChartConfigGenerator = (chartData, config) => {
  const cfg = config[0];
  const xKey = cfg?.x?.key || "x";

  const yKeys = Object.keys(cfg).filter(
    (key) => key !== "x" && key !== "groupBy"
  );

  const categories = chartData.map((item) => item[xKey]);

  const series = yKeys.map((yKey) => {
    const yField = cfg[yKey];
    return {
      name: yField?.title || yKey,
      data: chartData.map((item) => Number(item[yKey] || 0)),
      format: yField?.format || "number",
    };
  });

  const colors = cfg?.x?.colors || ["#3B82F6", "#10B981", "#F59E0B"];

  return {
    categories,
    series,
    colors,
    xAxisTitle: cfg?.x?.title || "X Axis",
    yAxisTitle: cfg?.[yKeys[0]]?.title || "Y Axis",
    format: series[0]?.format || "number",
  };
};




export const pieChartConfigGenerator = (chartData, config) => {
  const cfg = config[0];
  const xKey = "x";

  // Identify all Y keys (same pattern as your line chart)
  const yKeys = Object.keys(cfg).filter(
    (key) => key !== "x" && key !== "groupBy"
  );

  // For Pie charts, we expect only one Y key (like y1)
  const yField = cfg[yKeys[0]] || {};
  const yKey = yKeys[0];

  // Prepare data
  const categories = chartData.map((item) => item[xKey]);
  const series = chartData.map((item) => Number(item[yKey] || 0));

  const colors = cfg.x.colors || ["#3B82F6", "#22C55E", "#F59E0B", "#EF4444"];

  return {
    series,
    categories,
    colors,
    chartType: yField.type || "pie",
    title: yField.title || "Pie Chart",
    format: yField.format || "number",
  };
};

